(function () {
  'use strict';
  angular.module('vcdms.vcprinter')
    .component('printernew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="printernew-component" data-hook="printernew-component">
        <h3>Neue/s printer anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addPrinter()" ng-hide="vm.newprinter">Neue/s printer anlegen</div>
        <div ng-show="vm.newprinter">
          <printerform printer="vm.newprinter" parentsave="vm.saveNewPrinter(printer)" oncancel="vm.cancel()"></printerform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> printer erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen printer wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> printer konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Printer', 'Rlog',
        function ($log, Printer, Rlog) {
          let vm = this;
          vm.addPrinter = addPrinter;
          vm.saveNewPrinter = saveNewPrinter;
          vm.cancel = cancel;
          
          function addPrinter() {
            vm.newprinter = {};
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewPrinter(printer) {
            $log.debug('debug: create new printer: ', printer);
            delete vm.newprinter;
            Printer.$create(printer).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new printer failed: ', err);
              Rlog.error('vcutils.printer', 'printernew', 'Creation of new printer failed: ', {printer: vm.newprinter});
            });
          }
          
          function cancel() {
            delete vm.newprinter;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());